// src/Navbar.js
import React, { useState } from "react";
import { useNavigate} from "react-router-dom";

import Footer from "../components/Footer";

import Button from "react-bootstrap/Button";
import "./manufacturing.css";

import Icon1 from "../assets/Industry/Deployment.png"
import Icon2 from "../assets/Industry/Tracking.png"
import Icon3 from "../assets/Industry/Tasks.png"
import Icon4 from "../assets/Industry/ComboChart.png"
import Navbar from "../components/Navbar";

const Construction = () => {
  const navigate = useNavigate()
  const [activeTab, setActiveTab] = useState("workerSafety");

  const content = {
    workerSafety: {
      title: "WORKER SAFETY & ACCIDENT PREVENTION",
      description: [
        "Detect unsafe behaviors and generate instant alerts.",
        "Automate incident tracking for faster response.",
        "Analyze worker patterns to improve safety over time.",
      ],
      image: "construction .jpg",
    },
    ontimeDelivery: {
      title: "ON-TIME DELIVERY & PROJECT EFFICIENCY",
      description: [
        "Track task completion against schedules with live data.",
        "Identify process inefficiencies and resolve them proactively.",
        "Access project metrics anytime, from anywhere.",
      ],
      image: "construction 3.jpg", // Replace with your image URL or import it
    },
    smartAutomation: {
      title: "SMART AUTOMATION FOR PRODUCTIVITY",
      description: [
        "Monitor equipment and material usage to avoid overspending.",
        "Predict costs based on data trends to manage budgets better.",
        "Identify irregularities in material consumption and time logs.",
      ],
      image: "construction 2.jpg",
    },
    dataDrivenInsights: {
      title: "REMOTE MONITORING",
      description: [
        "Visualize live production data instantly.",
        "Optimize processes with actionable insights.",
        "Remote factory monitoring anytime, anywhere.",
      ],
      image: "100001550.jpeg",
    },
  };

  return (
    <div>
      <Navbar />
      <div className="spacer"></div>

      <div className="container-mirrored">
        <div className="image-section-mirrored">
          <img src="e.png" alt="Product Line" />
        </div>
        <div className="content-mirrored">
          <h1>
            Smarter Sites. Safer <br /> Builds.
          </h1>
          <h4 style={{ fontWeight: "300" }}>
            We track, monitor, and alert—so your site stays safer, your work
            flows smoother, and your teams get more done with less stress.
          </h4>
          <Button 
            onClick={()=>{navigate('/Demo')}}
            // href="https://forms.gle/P7B2NMVwGstAeVea8"
            className="know-more-btn"
          >
            Get Started
          </Button>
        </div>
      </div>

      <div className="centered-section">
        <h2>Isn't smart better than manual?</h2>
        <h6>
          We track what matters, flag what’s off, and help you stay
          ahead—without the mental overload.
        </h6>
      </div>

      <div className="app2">
        <div className="tabs2">
          {Object.keys(content).map((tabKey) => (
            <button
              key={tabKey}
              className={`tab2 ${activeTab === tabKey ? "active2" : ""}`}
              onClick={() => setActiveTab(tabKey)}
            >
              {content[tabKey].title.split(" & ")[0]}
            </button>
          ))}
        </div>

        <div className="content2">
          <div className="text-column2">
            <h2>{content[activeTab].title}</h2>
            <hr />
            <p>
              {content[activeTab].description.map((desc, index) => (
                <div key={index}>• {desc}</div>
              ))}
            </p>
          </div>
          <div className="image-column2">
            <img
              src={content[activeTab].image}
              alt={content[activeTab].title}
            />
          </div>
        </div>
      </div>

      <div className="app-container2">
        <header className="app-header2">
          <h1 className="title2">Industry Insights by the Numbers</h1>
        </header>

        <div className="statistics-container2">
          <div className="statistic-card2">
            <h2 className="statistic-percentage2">+25%</h2>
            <p className="statistic-description21">
              Project Schedule Adherence
            </p>
            <div className="card-divider2"></div>
            <p className="statistic-description2">
              Enhanced Project Management
            </p>
          </div>

          <div className="statistic-card2">
            <h2 className="statistic-percentage2">-10%</h2>
            <p className="statistic-description21">Project cost</p>
            <div className="card-divider2"></div>
            <p className="statistic-description2">
              Efficient Resource Management
            </p>
          </div>

          <div className="statistic-card2">
            <h2 className="statistic-percentage2">+30%</h2>
            <p className="statistic-description21">Labor Productivity</p>
            <div className="card-divider2"></div>
            <p className="statistic-description2">Personalised Experiences</p>
          </div>

          <div className="statistic-card2">
            <h2 className="statistic-percentage2">-20%</h2>
            <p className="statistic-description21">Material Wastage</p>
            <div className="card-divider2"></div>
            <p className="statistic-description2">Real-Time Monitoring</p>
          </div>
        </div>
      </div>

      <div className="app-container3">
        <div className="content3" style={{ textAlign: "left" }}>
          <h1 className="title3">
            Enhance Safety and Precision with Argus for Construction
          </h1>
          <Button
            onClick={()=>{navigate('/contact')}}
            className="connect-button3"
           
          >
            Connect Now
          </Button>
        </div>

        <div className="card-container3">
          <div className="card3">
            <div className="icon3">
              <img src={Icon1} style={{margin:"0", height:"70px"}} alt="Icon 1" />
            </div>
            <h3 className="card-title3">
              Error Reduction through tracking tools.​
            </h3>
          </div>

          <div className="card3">
            <div className="icon3">
              <img src={Icon2} style={{margin:"0", height:"70px"}} alt="Icon 1" />
            </div>
            <h3 className="card-title3">
              Comprehensive Monitoring of Safety and Resources
            </h3>
          </div>

          <div className="card3">
            <div className="icon3">
              <img src={Icon3} style={{margin:"0", height:"70px"}} alt="Icon 1" />
            </div>
            <h3 className="card-title3">
              Progress Visualization for accurate timelines.​
            </h3>
          </div>

          <div className="card3">
            <div className="icon3">
              <img src={Icon4} style={{margin:"0", height:"70px"}} alt="Icon 1" />
            </div>
            <h3 className="card-title3">
              Data Insights for informed decisions.
            </h3>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Construction;
